export const sotresData = [
    {
    name: "TOP 10 STORES",
    key: "top_ten_stores",
    stores: []
    },
    {
    name: "FASTEST GROWING",
    key: "top_ten_growing_stores",
    stores: []
    },
    {
    name: "TOP CITIES",
    key: "top_ten_cities",
    stores: []
    },
]

export const tooltipAttr = [
  {
    name: "Name",
    key: "name"
  },
  {
    name: "City",
    key: "city"
  },
  {
    name: "TY",
    key: "ty_amt"
  },
  {
    name: "LY",
    key: "ly_amt"
  },
  {
    name: "Stores",
    key: "store_count"
  },
  {
    name: "Age",
    key: "age"
  },
  {
    name: "Store Grade",
    key: "store_grade"
  },
]

export const defaultData =[
  {
    name: "Store 1"
  },
  {
    name: "Store 2"
  },
  {
    name: "Store 3"
  },
  {
    name: "Store 4"
  },
  {
    name: "Store 5"
  },
  {
    name: "Store 6"
  },
  {
    name: "Store 7"
  },
]
export const formatFixedOneNotation = (num, type = "") => {
    if (type === "value") return (num / 100000).toFixed(1).replace(/\.00$/, "") + "L";
    if (type === "qty") return (num / 1000).toFixed(1).replace(/\.00$/, "") + "K";
    return num.toString();
  };
export const formatIndianNumber = (num) => {
    if (num >= 10000000) return (num / 10000000).toFixed(1).replace(/\.00$/, "") + "Cr";
    if (num >= 100000) return (num / 100000).toFixed(1).replace(/\.00$/, "") + "L";
    if (num >= 1000) return (num / 1000).toFixed(1).replace(/\.00$/, "") + "K";
    return num.toString();
  };